export default __webpack_public_path__ + "eec2fb2fe021def22471bedf8b6feb5c.png";